import MockupSimpleView from './MockupSimpleView'

export default MockupSimpleView
